import AppDispatcher from 'dispatcher/MgfDispatcher';
import { ActionTypes } from 'constants/MgfConstants';
import Utils from 'util/Utils';
import WebUtils from 'util/WebUtils';
import AppApi from 'api';

class ExplorerActions {
  /* loadHotel(hotelId) {
    return AppApi.loadHotel(hotelId).then(hotel => {
      AppDispatcher.dispatch({
        actionType: ActionTypes.HOTEL_LOAD,
        hotel: hotel,
      })
    })
  }

  addCategory(params, path) {
    AppDispatcher.dispatch({
      actionType: ActionTypes.CATEGORY_ADD,
      category: params.category,
      path: path,
    })
  }

  createHotel(params) {
    return AppApi.createHotel(params).then(() => {
    })
  }

  loadHotelList(params) {
    AppApi.loadHotelList(params).then(hotelList => {
      AppDispatcher.dispatch({
        actionType: ActionTypes.HOTEL_LIST_LOAD,
        hotels: hotelList,
      })
    })
  } */

  /* setUserHotel(hotelId) {
    AppApi.setUserHotel(hotelId).then(hotel => {
      this.loadHotel()
      AppDispatcher.dispatch({
        actionType: ActionTypes.SET_USER_HOTEL,
        hotel: hotel,
      })
    })
  } */

  /* removeItem(params) {
    return AppApi.removeNode(params).then(() => {
      //this.loadHotel()
    })
  }

  uploadImage(image, hotelId) {
    AppApi.uploadImage(image, hotelId)
  } */

  login(authData) {
    const login = authData.tempKey ? (authData) => AppApi.loginViaAppleMpa(authData) : authData.socialToken ? (authData) => AppApi.loginViaFirebaseMpa(authData) : (authData) => AppApi.login(authData);
    return login(authData).then((resp) => this.handleAuthResponse(resp));
  }

  loginViaAccesslink(accesslink) {
    return AppApi.loginViaAccesslink(accesslink).then((resp) => this.handleAuthResponse(resp));
  }

  handleAuthResponse(resp) {
    if (resp.rez === 1) {
      if (Utils.isMpg() && resp.login) {
        localStorage.setItem('mpgLogin', resp.login);
      }
      AppDispatcher.dispatch({
        actionType: ActionTypes.AUTH,
        auth: {
          logged: true,
          token: resp.token,
          lang: resp.lang,
          userId: resp.userId,
          firstName: resp.firstName,
          lastName: resp.lastName,
          email: resp.email,
          login: resp.login,
          partnerId: resp.partnerId,
          admin: resp.admin,
          subAdmin: resp.subAdmin,
          operationsAccess: resp.operationsAccess,
          member: resp.member,
          role: resp.role,
          role2: resp.role2,
          salesKey: resp.salesKey,
          area: resp.area,
          tempAccess: resp.tempAccess,
          ctoolMpa: resp.ctoolMpa,
          initialPassed: resp.initialPassed,
          introPassed: resp.introPassed,
          myperfectapp: resp.myperfectapp,
          mypersonalguide: resp.mypersonalguide,
          corporateCtool: resp.corporateCtool,
          corporateCtoolApp: resp.corporateCtoolApp,
          chatNodeId: resp.chatNodeId,
          faqNodeId: resp.faqNodeId,
          newsNodeId: resp.newsNodeId,
          contractStatus: resp.contractStatus,
          goAfterLogin: resp.goAfterLogin ? resp.goAfterLogin : '/mob',
          allowPartnersIds: resp.allowPartnersIds,
          subappsAllowed: resp.subappsAllowed,
          demo: resp.demo,
          loginTs: new Date().getTime(),
        },
      });
      localStorage.setItem('token', resp.token);
      WebUtils.rmvCookie('token');
    } else {
      AppDispatcher.dispatch({
        actionType: ActionTypes.AUTH,
        auth: {
          logged: false,
          token: '',
          lang: 'en',
          userId: null,
          firstName: null,
          lastName: null,
          partnerId: null,
          tempAccess: false,
          ctoolMpa: false,
          initialPassed: true,
          myperfectapp: false,
          mypersonalguide: false,
          corporateCtool: false,
          corporateCtoolApp: false,
          introPassed: true,
          chatNodeId: undefined,
          faqNodeId: undefined,
          newsNodeId: undefined,
          contractStatus: 0,
          goAfterLogin: '/mob',
          role: undefined,
          role2: undefined,
          salesKey: undefined,
          allowPartnersIds: undefined,
          subappsAllowed: undefined,
          demo: undefined,
          loginTs: undefined,
          area: undefined,
        },
      });
      localStorage.removeItem('token');
    }
    return resp;
  }

  logout() {
    const mobUserId = localStorage.getItem('mobUserId');
    if (!!mobUserId && mobUserId !== '') {
      try {
        AppApi.logout(mobUserId);
      } catch (e) {}
    }
    AppDispatcher.dispatch({
      actionType: ActionTypes.LOGOUT,
    });
  }
}

export default new ExplorerActions();
